import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm3.3 15H9V7h6.286v1.5H10.68v2.771h3.948V12.7H10.68v2.8h4.62V17z" }));
export default createSvgIcon(iconPath, "Editions");
//# sourceMappingURL=EditionsIcon.js.map